export interface User {
  id: string;
  username: string;
  accessLevel: 1 | 2 | 3;
  role?: 'admin' | 'user' | 'manager' | 'resident';
  roomNumber?: string;
}

export const USERS = [
  { id: '1', username: 'irfan', password: '42532439', accessLevel: 1 },
  { id: '2', username: 'oeoel', password: 'mieayambaksoo', accessLevel: 1 },
  { id: '3', username: 'yudha', password: '123456', accessLevel: 3 }
] as const;

// Fallback credentials for resident accounts (when Supabase not reachable yet)
// These mirror the seed data in migration 20250831103000_resident_accounts.sql
export const RESIDENT_FALLBACKS: { username: string; password: string; roomNumber: string; buildingType?: 'gajah4' | 'gajah3' }[] = [
  // Kos Gajah 4
  { username: '1', password: 'ceria_kucing', roomNumber: '1', buildingType: 'gajah4' },
  { username: '2', password: 'lucu_pisang', roomNumber: '2', buildingType: 'gajah4' },
  { username: '3', password: 'riang_badak', roomNumber: '3', buildingType: 'gajah4' },
  { username: '4', password: 'lentik_kupu', roomNumber: '4', buildingType: 'gajah4' },
  { username: '5', password: 'kenyal_cendol', roomNumber: '5', buildingType: 'gajah4' },
  { username: '6', password: 'renyah_rempeyek', roomNumber: '6', buildingType: 'gajah4' },
  { username: '7', password: 'riang_pelangi', roomNumber: '7', buildingType: 'gajah4' },
  { username: '8', password: 'wangi_melati', roomNumber: '8', buildingType: 'gajah4' },
  { username: '9', password: 'gurih_tempe', roomNumber: '9', buildingType: 'gajah4' },
  { username: '10', password: 'manis_serabi', roomNumber: '10', buildingType: 'gajah4' },
  { username: '101', password: 'lincah_tupai', roomNumber: '101', buildingType: 'gajah4' },
  { username: '102', password: 'teduh_awan', roomNumber: '102', buildingType: 'gajah4' },
  { username: '103', password: 'hangat_senja', roomNumber: '103', buildingType: 'gajah4' },
  { username: '104', password: 'bening_embun', roomNumber: '104', buildingType: 'gajah4' },
  { username: '105', password: 'damai_sawah', roomNumber: '105', buildingType: 'gajah4' },
  { username: '106', password: 'santai_pantai', roomNumber: '106 (AC)', buildingType: 'gajah4' },
  { username: '107', password: 'jingga_fajar', roomNumber: '107', buildingType: 'gajah4' },
  { username: '108', password: 'rimbun_bambu', roomNumber: '108', buildingType: 'gajah4' },
  { username: '200', password: 'sejuk_pagi', roomNumber: '200', buildingType: 'gajah4' },
  { username: '201', password: 'lembut_sutra', roomNumber: '201', buildingType: 'gajah4' },
  { username: '202', password: 'ringan_awan', roomNumber: '202', buildingType: 'gajah4' },
  { username: '203', password: 'bahagia_senyum', roomNumber: '203', buildingType: 'gajah4' },
  { username: '204', password: 'cepat_kilat', roomNumber: '204', buildingType: 'gajah4' },
  { username: '205', password: 'kilau_bintang', roomNumber: '205', buildingType: 'gajah4' },
  { username: '206', password: 'nyala_pelita', roomNumber: '206', buildingType: 'gajah4' },
  { username: '207', password: 'jernih_telaga', roomNumber: '207', buildingType: 'gajah4' },
  { username: '208', password: 'wibawa_elang', roomNumber: '208', buildingType: 'gajah4' },
  { username: '209', password: 'gagah_harimau', roomNumber: '209', buildingType: 'gajah4' },
  { username: '210', password: 'tangguh_karang', roomNumber: '210', buildingType: 'gajah4' },
  { username: '211', password: 'gemas_koala', roomNumber: '211', buildingType: 'gajah4' },
  { username: '212', password: 'kalem_panda', roomNumber: '212', buildingType: 'gajah4' },
  { username: '301', password: 'cerah_mentari', roomNumber: '301', buildingType: 'gajah4' },
  { username: '302', password: 'ramah_desa', roomNumber: '302', buildingType: 'gajah4' },
  { username: '303', password: 'hening_dedaun', roomNumber: '303', buildingType: 'gajah4' },
  { username: '304', password: 'segar_kelapa', roomNumber: '304', buildingType: 'gajah4' },
  { username: '305', password: 'adem_sumur', roomNumber: '305', buildingType: 'gajah4' },
  { username: '306', password: 'riuh_hujan', roomNumber: '306', buildingType: 'gajah4' },
  { username: '307', password: 'lembayung_sore', roomNumber: '307', buildingType: 'gajah4' },
  { username: '308', password: 'purnama_laut', roomNumber: '308', buildingType: 'gajah4' },
  
  // Kos Gajah 3
  { username: 'G3-01', password: 'kunci_merah', roomNumber: 'G3-01', buildingType: 'gajah3' },
  { username: 'G3-02', password: 'buku_hijau', roomNumber: 'G3-02', buildingType: 'gajah3' },
  { username: 'G3-03', password: 'lampu_kuning', roomNumber: 'G3-03', buildingType: 'gajah3' },
  { username: 'G3-04', password: 'meja_biru', roomNumber: 'G3-04', buildingType: 'gajah3' },
  { username: 'G3-05', password: 'kursi_ungu', roomNumber: 'G3-05', buildingType: 'gajah3' }
];